import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import isNil from 'lodash/isNil'
import uniqBy from 'lodash/uniqBy'
import { SketchPicker } from 'react-color'
import { shapeUtils } from './shape-utils'
import LockOpen from '@mui/icons-material/LockOpen';
import Lock from '@mui/icons-material/Lock';
import { collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import { disableMapObject, enableMapObject } from '../../../../../action/disable-map-obj-state-action'
import { lineCreateRequest, lineUpdateRequest, lineDeleteRequest } from '../../../../../action/line-actions'
import { circleCreateRequest, circleUpdateRequest, circleDeleteRequest } from '../../../../../action/circle-actions'
import { polygonCreateRequest, polygonUpdateRequest, polygonDeleteRequest } from '../../../../../action/polygon-actions'
import { trackUpdateRequest, trackDeleteRequest } from '../../../../../action/track-actions'
import { ConnectedElevationChart as ElevationChart } from '../../../common/charts'
import TrackChart from '../track-details/track-chart'
import StyleControls from '../track-details/style-controls'
import { TRACK_COLORS, TRACK_WIDTHS, normalizeTrackWidth, trackPolylineOptions } from '../../../../../lib/trackColor'
import { MEASUREMENT_TYPES } from '../../../../../lib/enums'
import ObjectDetails from './object-details'
import { blockFeatures, unBlockFeatures } from '../../../../../action/features-blocked-actions'
import ConfirmRemoval from '../confirm-removal'
import { boundaryDeleteRequest, boundaryUpdateRequest } from '../../../../../action/boundary-actions'
import { formatNumberWithCommas } from '../../../../../lib/util'
import { formatLongDate } from '../../../../../lib/util'
import { photoUploadRequest } from '../../../../../action/photo-actions'
import html2canvas from 'html2canvas';
import TooManyObjects from '../tooMany-object'
import { showHideSubscriptionModal } from '../../../../../utils/subscriptionUtils';

// Line style options (matches the track editor).
const LINE_STYLES = ['dots', 'dashed', 'solid']


class ShapeDetails extends React.Component {
  constructor(props) {
    super(props)
    const { leftToolbarState, circles, lines, polygons, type } = props,
      { editable } = leftToolbarState

    this.state = {
      id: '',
      name: type === 'line' ? `Line - ${lines.length}` : type === 'circle' ? `Circle - ${circles.length}` : type === 'polygon' ? `Shape - ${polygons.length}` : '',
      shapeName: '',
      nameValue: type === 'line' ? `Line - ${lines.length}` : type === 'circle' ? `Circle - ${circles.length}` : type === 'polygon' ? `Shape - ${polygons.length}` : '',
      notes: '',
      shapeNotes: '',
      photoId: '',
      // Default to a palette blue so a track-style swatch is highlighted (lines,
      // circles and polygons all use the shared palette now).
      color: '#3399FF',
      lineStyle: 'solid',
      lineWidth: 4,
      propertiesSet: !isNil(editable),
      unlocked: isNil(editable) || editable && editable.measureType === 'track',
      pickingColor: false,
      doubleClicked: false,
      confirmRemoval: false,
      colorDidMount: '',
      noUndo: false,
      geoJsonState: null,
      entriesData: [],
      elevationProfile: [],
      screenshot: null,
      loadSpinner: false,
      shapePoints: false,
      pathLength: 0,
      tooManyObjects: false
    }
    this.prevCircleRadius = null
    this.prevClick = 0
    this.moveListener = null
    this.clickListener = null
    this.dblClickListener = null
    this.editListener = null
    this.shape = null
    this.geoJson = null
    this.labels = []
    this.chartData = []
    this.setChartData = this.setChartData.bind(this)
    this.onChange = this.onChange.bind(this);
    this.infoBox = null
    this.setLineInfo = this.setLineInfo.bind(this)
    this.setCircleInfo = this.setCircleInfo.bind(this)
    this.setPolyInfo = this.setPolyInfo.bind(this)
    this.setInfoEntries = this.setInfoEntries.bind(this)
    this.doublePending = false
    this.elevationCache = []
    this.saveShape = this.saveShape.bind(this);
  }

  async componentDidMount() {
    const { leftToolbarState, mapReference, type, userPreferences } = this.props,
      { units } = userPreferences,
      { editable } = leftToolbarState,
      { color } = this.state,
      shapeType = editable ? editable.measureType : type ? type : null
    if (isNil(editable)) {
      this.shape = shapeUtils.create(type, { color })
      if (type === 'circle') {
        this.addCircleListeners()
      } else {
        this.addPolyListeners()
        this.shape?.getPath()?.setAt(0, mapReference.getCenter())
        this.shape && this.shape.setMap(mapReference)
      }
    } else {
      const shapeDetails = Object.assign(this.state, editable)
      if (editable.geoJson) {
        this.geoJson = JSON.parse(editable.geoJson)
        shapeDetails['color'] = this.geoJson.features[0].properties.line ? this.geoJson.features[0].properties.line.color : this.geoJson.features[0].properties.color
        this.setState({ colorDidMount: shapeDetails['color'] })
        // Seed the line style/width selectors from the saved line properties.
        const _line = this.geoJson.features[0].properties.line
        if (_line) {
          const _w = normalizeTrackWidth(_line.width)
          const _wSnap = TRACK_WIDTHS.some(w => w.value === _w) ? _w : 4
          if (shapeType === 'line') {
            this.setState({
              lineStyle: (_line.style === 'dashed' || _line.style === 'dots') ? _line.style : 'solid',
              lineWidth: _wSnap
            })
          } else if (shapeType === 'circle' || shapeType === 'polygon') {
            this.setState({ lineWidth: _wSnap })
          }
        }
      }
      if (shapeType) {
        if (shapeType === 'line') {
          this.checkFunction(shapeDetails, this.props.lines)
        } else {
          this.setState(shapeDetails)
          this.setState({ nameValue: editable.name, })
        }
      }
      this.setState({ shapeName: this.state.name, shapeNotes: this.state.notes })
      this.shape = editable.mapObj ? editable.mapObj() : null;
      if (shapeDetails.measureType !== 'track' && shapeDetails.measureType !== 'circle') {
        this.setState({ pathLength: this.shape?.getPath?.()?.length })
      }

      if (shapeDetails.measureType === 'track') {
        this.setChartData()
      }
    }
    if (shapeType) {
      if (shapeType === 'line') {
        this.setLineInfo()
      } else if (shapeType === 'polygon') {
        this.setPolyInfo()
      } else if (shapeType === 'circle') {
        this.setCircleInfo()
      }
    }
  }

  checkFunction = (oldData, propsData, unmount) => {
    if (propsData) {
      let value = propsData.filter((item) => {
        return oldData.id == item.id
      })
      let colorCode = JSON.parse(value[0].geoJson)
      let colorValue = colorCode.features && (colorCode.features[0].properties.line?.color ?? colorCode.features[0].properties.color)
      this.setState(value[0])
      this.setState({ nameValue: value[0].name, color: colorValue })
      if (unmount) {
        const colorSettings = this.props.leftToolbarState.editable.measureType === 'line' ? { strokeColor: colorValue } :
          { strokeColor: colorValue, fillColor: colorValue }
        const geoJson = JSON.parse(value[0].geoJson);
        let coords
        if (this.props.leftToolbarState.editable.measureType === 'line') {
          coords = geoJson.features[0].geometry.coordinates.map(coord => new google.maps.LatLng(coord[1], coord[0]));
        }
        if (this.props.leftToolbarState.editable.measureType === 'polygon') {
          coords = geoJson.features[0].geometry.coordinates[0].map(coord => new google.maps.LatLng(coord[1], coord[0]))
        }
        if (this.props.leftToolbarState.editable.measureType === 'circle') {
          coords = new google.maps.LatLng(geoJson.features[0].geometry.coordinates[1], geoJson.features[0].geometry.coordinates[0])
        }
        if (this.shape) {
          this.shape.setOptions(colorSettings)
          typeof this.shape.setEditable === 'function' && this.shape.setEditable(false)
          this.props.leftToolbarState.editable.measureType === 'circle' ? this.shape.setCenter(coords) : typeof this.shape.setPath === 'function' && this.shape.setPath(coords)
          this.props.leftToolbarState.editable.measureType === 'circle' && this.shape.setRadius(geoJson.features[0].properties.radius)
        }
      }
    }
  }

  setInfoEntries(entries) {
    const { mapReference, leftToolbarState } = this.props,
      { editable } = leftToolbarState,
      { shape, infoBox } = this
    if (infoBox === null && !editable) {
      this.infoBox = shapeUtils.addInfoBox(shape, entries)
      this.infoBox.setMap(mapReference)
    } else {
      !editable && shapeUtils.updateInfoBox(shape, entries, infoBox)
    }
  }


  setLineInfo(ignore = 0, isDouble = false) {
    const { userPreferences, token } = this.props;
    const { units } = userPreferences;
    const { editable } = this.props.leftToolbarState;

    // 🔐 Strong guard
    if (!this.shape || typeof this.shape.getPath !== 'function') {
      return;
    }

    const path = this.shape.getPath();
    if (!path || typeof path.getLength !== 'function') {
      return;
    }

    const pathLength = path.getLength();

    if (pathLength && pathLength - ignore >= 2) {
      if (!editable) {
        this.setState({ noUndo: true }, () => {
          if (this.shape && this.shape.getPath && document.getElementById('undo-button')) {
            document.getElementById('undo-button').removeAttribute('disabled');
          }
        });
      }

      // One fetch gives both the gain (res) and the per-vertex elevations, which feed
      // the live line elevation profile (WEB-7020). Reuses the incremental cache.
      const shapeType = editable ? editable.measureType : this.props.type
      const elevationPromise = shapeUtils.getLineElevation(this.shape, token, ignore, this.elevationCache)
      elevationPromise
        .then(({ gain: res, elevations, coords }) => {
          if (shapeType === 'line') {
            const profile = shapeUtils.buildLineProfile(coords, elevations)
            this.setState({ elevationProfile: profile.length >= 2 ? profile : [] })
          }
          if (!this.doublePending || (this.doublePending && isDouble)) {
            const scale = units === 'imperial' ? 3.28084 : 1;
            const eleStr = `${formatNumberWithCommas(Math.round(res > 0 ? res * scale : 0))} ${units === 'imperial' ? 'ft' : 'm'}`;

            const len = shapeUtils.getLength(this.shape, units, ignore).toFixed(2);
            const lengthInMilesOrKm = parseFloat(len);

            let lenStr;
            if (units === 'imperial') {
              if (lengthInMilesOrKm < 0.5) {
                const lengthInYards = Math.round(lengthInMilesOrKm * 1760);
                lenStr = `${formatNumberWithCommas(lengthInYards)} yards`;
              } else {
                lenStr = `${formatNumberWithCommas(len)} mi`;
              }
            } else {
              if (lengthInMilesOrKm < 0.5) {
                const lengthInMeters = Math.round(lengthInMilesOrKm * 1000);
                lenStr = `${formatNumberWithCommas(lengthInMeters)} meters`;
              } else {
                lenStr = `${formatNumberWithCommas(len)} km`;
              }
            }

            this.setState({
              entriesData: [
                ['Length', lenStr],
                ['Elevation Gain', eleStr]
              ]
            });

            this.setInfoEntries({
              header: this.state.name,
              entries: [
                ['Length', lenStr],
                ['Elevation Gain', eleStr]
              ]
            });
          }
        });
    }
    else if (pathLength && pathLength > 1) {
      this.setInfoEntries({
        header: this.state.name,
        entries: [
          ['Length', '...'],
          ['Elevation Gain', '...']
        ]
      });
    }

    // GeoJSON only if shape is valid
    if (typeof shapeUtils.createGeoLine === 'function') {
      const geo = shapeUtils.createGeoLine(this.shape, false, this.state.lineStyle, this.state.lineWidth);
      if (geo) {
        const geoJson = JSON.parse(geo);
        editable && this.setState({ geoJsonState: geoJson });
      }
    }
  }


  // setLineInfo(ignore = 0, isDouble = false) {
  //   const { userPreferences, token } = this.props,
  //     { units } = userPreferences,
  //     pathLength = this.shape?.getPath()?.getLength() ?? null;

  //   const { editable } = this.props.leftToolbarState;

  //   if (pathLength && pathLength - ignore >= 2) {
  //     if (!editable) {
  //       this.setState({ noUndo: true }, () => {
  //         this.shape?.getPath() && document.getElementById('undo-button').removeAttribute('disabled');
  //       });
  //     }
  //     shapeUtils.getElevationGain(this.shape, token, ignore)
  //       .then(res => {
  //         if (!this.doublePending || (this.doublePending && isDouble)) {
  //           const scale = units === 'imperial' ? 3.28084 : 1,
  //             eleStr = `${formatNumberWithCommas(Math.round(res > 0 ? res * scale : 0))} ${units === 'imperial' ? 'ft' : 'm'}`;
  //           // Get the length of the shape
  //           const len = shapeUtils.getLength(this.shape, units, ignore).toFixed(2),
  //             lengthInMilesOrKm = parseFloat(len);
  //           // Initialize length display variable
  //           let lenStr;
  //           // Imperial: show in yards if less than 0.5 miles
  //           if (units === 'imperial') {
  //             if (lengthInMilesOrKm < 0.5) {
  //               const lengthInYards = Math.round(lengthInMilesOrKm * 1760);  // Convert miles to yards
  //               lenStr = `${formatNumberWithCommas(lengthInYards)} yards`;
  //             } else {
  //               lenStr = `${formatNumberWithCommas(len)} mi`;
  //             }
  //           }
  //           // Metric: show in meters if less than 0.5 km
  //           else {
  //             if (lengthInMilesOrKm < 0.5) {
  //               const lengthInMeters = Math.round(lengthInMilesOrKm * 1000);  // Convert km to meters
  //               lenStr = `${formatNumberWithCommas(lengthInMeters)} meters`;
  //             } else {
  //               lenStr = `${formatNumberWithCommas(len)} km`;
  //             }
  //           }
  //           this.setState({
  //             entriesData: [
  //               ['Length', lenStr],
  //               ['Elevation Gain', eleStr]
  //             ]

  //           })

  //           this.setInfoEntries({
  //             header: this.state.name,
  //             entries: [
  //               ['Length', lenStr],
  //               ['Elevation Gain', eleStr]
  //             ]
  //           });
  //         }
  //       });
  //   } else if (pathLength && pathLength > 1) {
  //     this.setInfoEntries({
  //       header: this.state.name,
  //       entries: [
  //         ['Length', '...'],
  //         ['Elevation Gain', '...']
  //       ]
  //     });
  //   }
  //   const geo = shapeUtils.createGeoLine(this.shape),
  //     geoJson = JSON.parse(geo);
  //   editable && this.setState({ geoJsonState: geoJson });
  // }

  setPolyInfo(ignore = 0, isDouble = false) {
    const { editable } = this.props.leftToolbarState
    const { userPreferences } = this.props,
      { units } = userPreferences

    const { getLength, getArea } = shapeUtils
    if (!editable) {
      this.setState({ noUndo: true }, () => {
        document.getElementById('undo-button').removeAttribute('disabled');
      })
    }
    const mapObj = editable && editable.mapObj ? editable.mapObj() : this.shape
    const area = formatNumberWithCommas(getArea(mapObj, units).toFixed(2)),
      per = getLength(mapObj, units).toFixed(2)

    let perStrVal = units === 'imperial'
      ? (per <= 0.25
        ? Math.round(per * 5280)   // Convert to feet for small values
        : per)          // Keep two decimal places for values larger than 0.25
      : per,
      perValu = formatNumberWithCommas(perStrVal),
      areaStr = area <= 0.25
        ? ` ${units === 'imperial' ? (area * 43560).toLocaleString() + " " + 'sq ft' : area + " " + 'ha'}`
        : `${area} ${units === 'imperial' ? 'ac' : 'ha'}`,
      perStr = units === 'imperial'
        ? (per <= 0.25 ? perValu + ' ft' : perValu + ' mi')   // Append the correct unit
        : perValu + ' km';

    this.setState({
      entriesData: [
        ['Area', areaStr],
        ['Perimeter', perStr]
      ]
    })

    this.setInfoEntries({
      header: this.state.name,
      entries: [
        ['Area', areaStr],
        ['Perimeter', perStr]
      ]
    })

    const pathLength = this.shape.getPath ? this.shape?.getPath().length : null
    if (pathLength && pathLength > 1) {
      this.setInfoEntries({
        header: this.state.name,
        entries: [
          ['Area', areaStr],
          ['Perimeter', perStr]
        ]
        // entries: [
        //   ['Area', '...123'],
        //   ['Perimeter', '...1234']
        // ]
      })
    }
    const geo = shapeUtils.createGeoPoly(this.shape, this.state.lineWidth),
      geoJson = JSON.parse(geo)
    editable && this.setState({ geoJsonState: geoJson })
  }

  setCircleInfo() {
    const { userPreferences } = this.props,
      { units } = userPreferences

    if (this.shape.getRadius) {
      const denom = units === 'imperial' ? this.shape.getRadius() < 402 ? .328074 : 1609.344 : 1000,
        scale = units === 'imperial' ? 0.000247105 : 0.0001,
        shapeRad = this.shape.getRadius() / denom,
        rad = this.shape.getRadius() < 402 ? formatNumberWithCommas(shapeRad.toFixed()) : formatNumberWithCommas(shapeRad.toFixed(2)),
        radStr = `${rad} ${units === 'imperial' ? this.shape.getRadius() < 402 ? 'ft' : 'mi' : 'km'}`,
        areaRaw = (Math.PI * Math.pow(this.shape.getRadius(), 2)) * scale,
        area = formatNumberWithCommas(areaRaw.toFixed(2)),
        areaStr = `${area} ${units === 'imperial' ? 'ac' : 'ha'}`
      this.setState({
        entriesData: [
          ['Radius', radStr],
          ['Area', areaStr]
        ]
      })

      this.setInfoEntries({
        header: this.state.name,
        entries: [
          ['Radius', radStr],
          ['Area', areaStr]
        ]
      })
    }
  }

  setChartData() {
    const geo = this.geoJson.features[0].geometry.coordinates || null
    if (geo) {
      let dist = 0
      const chartData = geo.map((val, idx) => {
        if (idx === 0) {
          return [0, val[2]]
        } else {
          const currPos = new google.maps.LatLng(val[1], val[0]),
            prevPos = new google.maps.LatLng(geo[idx - 1][1], geo[idx - 1][0]),
            currDist = idx === 0 ? 0 : google.maps.geometry.spherical.computeDistanceBetween(currPos, prevPos)

          dist += currDist
          return [dist, val[2]]
        }
      })
      this.chartData = chartData
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const prevType = prevProps.type,
      { mapReference, type, circles, lines, polygons } = this.props,
      { editable } = this.props.leftToolbarState,
      prevEditable = prevProps.leftToolbarState.editable,
      { color, entriesData } = this.state,
      { shape, infoBox } = this

    const shapeDetails = Object.assign(this.state, editable)
    if (editable && editable.id !== prevEditable.id) {
      if (editable.measureType === 'line') {
        this.setLineInfo()
      }
      if (editable.measureType === 'polygon') {
        this.setPolyInfo()
      }
      if (editable.measureType === 'circle') {
        this.setCircleInfo()
      }
      if (this.infoBox && this.infoBox.map === null) {
        this.infoBox.setMap(mapReference)
      }
      this.geoJson = JSON.parse(editable.geoJson)
      shapeDetails['color'] = this.geoJson.features[0].properties.line.color
      this.setState(shapeDetails)
      this.setState({ shapeName: this.state.name, nameValue: this.state.name, shapeNotes: this.state.notes })
      this.shape = editable.mapObj()
      if (shapeDetails.measureType === 'track') {
        this.setChartData()
      }
    }

    if (prevType !== type) {
      const name = type === 'circle' ? `Circle - ${circles.length + 1}` :
        type === 'line' ? `Line - ${lines.length + 1}` : type === 'polygon' ?
          `Shape - ${polygons.length + 1}` : ''
      this.setState({ name, nameValue: name })
      this.shape.setMap(null)
      this.shape = null
      this.removeListeners()
      this.shape = shapeUtils.create(type, { color })
      if (type === 'polygon' || type === 'line') {
        this.shape.setMap(mapReference)
        this.shape.getPath()?.setAt(0, mapReference.getCenter())
        this.addPolyListeners()
      } else if (type === 'circle') {
        this.addCircleListeners()
      }
    }

    if (prevState.name !== this.state.name) {
      let updatedValue = {
        header: this.state.name,
        entries: entriesData
      }
      this.state.entriesData.length > 0 && shapeUtils.updateInfoBox(shape, updatedValue, infoBox, false)
    }
  }

  componentWillUnmount() {
    this.removeListeners()
    if (isNil(this.props.leftToolbarState.editable)) {
      this.shape.setMap(null)
    } else if (this.props.leftToolbarState.editable) {
      if (this.shape && this.props.leftToolbarState.editable.measureType !== 'track') {
        const shapeDetails = Object.assign(this.state, this.props.leftToolbarState.editable)
        typeof this.shape?.setEditable === 'function' && this.shape.setEditable(false)
        if (this.shape && this.props.leftToolbarState.editable.measureType === 'line') {
          this.checkFunction(shapeDetails, this.props.lines, true)
        } else if (this.shape && this.props.leftToolbarState.editable.measureType === 'polygon') {
          this.checkFunction(shapeDetails, this.props.polygons, true)
        } else if (this.shape && this.props.leftToolbarState.editable.measureType === 'circle') {
          this.checkFunction(shapeDetails, this.props.circles, true)
        }
      }
    }

    if (this.infoBox) {
      this.infoBox.setMap(null)
    }
    this.removeEditListener()
  }

  addPolyListeners() {
    const { mapReference, token, blockFeatures } = this.props
    blockFeatures()
    this.shape.setOptions({ clickable: false })
    mapReference.setOptions({
      draggableCursor: 'crosshair',
      disableDoubleClickZoom: true
    })
    this.moveListener = mapReference.addListener('mousemove', (e) => {
      const path = this.shape?.getPath()
      if (path) path.setAt(path.getLength() - 1, e.latLng)
      if (path.getLength() > 1) {
      }
    })
    this.clickListener = google.maps.event.addListener(mapReference, 'click', (e) => {
      const path = this.shape.getPath(),
        { editable } = this.props.leftToolbarState,
        shapeType = editable ? editable.measureType : this.props.type ? this.props.type : null
      path.push(e.latLng)
      if (path.getArray().length > 2 && !this.state.propertiesSet) {
        this.setState({ propertiesSet: true })
      }
      if (shapeType === 'line') {
        if (path.getArray().length > 2) {
          this.setState({ shapePoints: true })
        }
        this.setLineInfo(1, false)
      }
      if (shapeType === 'polygon') {
        if (path.getArray().length > 3) {
          this.setState({ shapePoints: true })
        }
        this.setPolyInfo(1, false)
      }
      this.setState({ pathLength: this.shape?.getPath().length })
    })
    this.dblClickListener = google.maps.event.addListenerOnce(mapReference, 'dblclick', (e) => {
      this.doublePending = true
      const { editable } = this.props.leftToolbarState,
        path = this.shape.getPath(),
        shapeType = editable ? editable.measureType : this.props.type ? this.props.type : null
      // path.pop()
      // path.pop()

      if (shapeType === 'line') {
        this.setLineInfo(0, true)
      }
      if (shapeType === 'polygon') {
        this.setPolyInfo(0, true)
      }
      this.removeListeners()
      // Let the finished shape be dragged to move it (like a circle). Drawing set
      // clickable:false, so restore it — a shape must be clickable to be draggable.
      if (this.shape && typeof this.shape.setOptions === 'function') {
        this.shape.setOptions({ clickable: true, draggable: true })
      }
      this.setState({ doubleClicked: true }, () => {
        setTimeout(() => {
          mapReference.setOptions({ disableDoubleClickZoom: false })
        }, 100)
      })
      this.setState({ pathLength: shapeType === 'line' ? this.shape?.getPath().length + 1 : this.shape?.getPath().length })
    })
  }

  onUndoValue() {
    const { type } = this.props;

    if (type === 'line') {
      const path = this.shape.getPath();
      this.setState({ pathLength: this.shape?.getPath().length })
      let updateState = false;
      if (path.getLength() <= 2) {
        updateState = true;
        this.setState({ shapePoints: false })
      }
      if (path && path.getLength() > 0) {
        path.pop();
        typeof this.shape.setPath === 'function' && this.shape.setPath(path);
        this.setLineInfo(1, false)
      } else {
        console.warn('No points to undo.');
        this.setState({ noUndo: false })
      }
      if (updateState) {
        this.setState({ noUndo: false }, () => {
          if (!this.state.noUndo) {
            document.getElementById('undo-button').style.backgroundColor = 'grey';
            document.getElementById('undo-button').style.cursor = 'no-drop';
            document.getElementById('undo-button').setAttribute('disabled', 'disabled');
          } else {
            document.getElementById('undo-button').removeAttribute('disabled');
          }
        });
      }
    }

    if (type === "polygon") {
      const path = this.shape.getPath();
      let updateState = false;
      if (path.length < 4) {
        path.pop();
        this.setState({ shapePoints: false, pathLength: path.length })
        updateState = true;
      } else if (path && path.getLength() > 0) {
        path.pop();
        typeof this.shape.setPath === 'function' && this.shape.setPath(path);
        this.setState({ noUndo: true, pathLength: path.length })
        this.setPolyInfo(0, true)
      } else {
        path.pop();
        this.setState({ noUndo: false, pathLength: path.length })
      }
      if (updateState) {
        this.setState({ noUndo: !this.state.noUndo }, () => {
          if (!this.state.noUndo) {
            document.getElementById('undo-button').style.backgroundColor = 'grey';
            document.getElementById('undo-button').style.cursor = 'no-drop';
            document.getElementById('undo-button').setAttribute('disabled', 'disabled');
          } else {
            document.getElementById('undo-button').removeAttribute('disabled');
          }
        });
      }
    }
    if (type === 'circle') {
      const currentRadius = this.shape.getRadius();
      if (currentRadius > 0) {
        const newRadius = this.prevCircleRadius; // You can adjust this value based on your needs
        this.shape.setRadius(newRadius);
      } else {
        console.warn('No radius to undo.');
      }
    }

  }

  addCircleListeners() {
    const { mapReference, token } = this.props
    mapReference.setOptions({ draggableCursor: 'crosshair' })
    this.clickListener = google.maps.event.addListenerOnce(mapReference, 'click', (e) => {
      this.shape.setMap(mapReference)
      this.shape.setCenter(e.latLng)
      //initial radius should be visible and about the same visual size at all zoom levels
      this.shape.setRadius(Math.pow(2, (25 - mapReference.getZoom())) / 3)
      this.removeListeners()
      this.setState({ propertiesSet: true })
      this.setCircleInfo()
      this.prevCircleRadius = this.shape.getRadius()
    })
    this.attachEditListener()
  }

  updateLabels() {
    const { mapReference } = this.props,
      newLabels = shapeUtils.addLabels(this.shape)
    this.labels.forEach(label => label.setMap(null))
    newLabels.forEach(label => label.setMap(mapReference))
    this.labels = newLabels
  }

  attachEditListener() {
    if (this.editListener === null) {
      const { editable } = this.props.leftToolbarState;
      const { type } = this.props;
      const measureType = editable ? editable.measureType : type;
      const { shape } = this;
      if (measureType === 'circle') {
        google.maps.event.addListener(shape, 'radius_changed', () => {
          this.setCircleInfo();
        });
      } else if (measureType === 'line') {
        google.maps.event.addListener(shape.getPath(), 'insert_at', this.handlePathChange);
        google.maps.event.addListener(shape.getPath(), 'remove_at', this.handlePathChange);
        google.maps.event.addListener(shape.getPath(), 'set_at', this.handlePathChange);
        this.setLineInfo(0, true);
      } else if (measureType === 'polygon') {
        google.maps.event.addListener(shape.getPath(), 'insert_at', this.handlePathChange);
        google.maps.event.addListener(shape.getPath(), 'remove_at', this.handlePathChange);
        google.maps.event.addListener(shape.getPath(), 'set_at', this.handlePathChange);
        this.setPolyInfo(0, true,);
      }
    }
  }

  handlePathChange = () => {
    const { editable } = this.props.leftToolbarState;
    const { type } = this.props;
    const measureType = editable ? editable.measureType : type;
    if (measureType === 'line') {
      // Call setLineInfo whenever path length changes for a line
      this.setLineInfo(0, true);
    } else if (measureType === 'polygon') {
      // Call setPolyInfo whenever path length changes for a polygon
      this.setPolyInfo(0, true);
    }
  };

  removeEditListener() {
    if (this.editListener !== null) {
      this.editListener.remove()
      this.editListener = null
    }
  }

  removeListeners() {
    const { mapReference, unBlockFeatures } = this.props
    if (this.clickListener !== null) {
      this.clickListener.remove()
      this.clickListener = null
    }
    if (this.dblClickListener !== null) {
      this.dblClickListener.remove()
      this.dblClickListener = null
    }
    if (this.moveListener !== null) {
      this.moveListener.remove()
      this.moveListener = null
    }
    unBlockFeatures()
    mapReference.setOptions({ draggableCursor: 'grab' })
  }

  makeTextInput(properties) {
    const { name, width, label } = properties
    return (
      <div style={{ width }} key={`markerInput-${properties.name}`}>
        <label htmlFor={label}
          style={{
            fontSize: '12px',
            textTransform: 'capitalize'
          }}>{`${label}:`}</label>
        {/* <input type='text'
          name={name}
          id={name}
          className='default-name-textfield'
          style={{
            marginTop: '5px',
          }}
          placeholder={label}
          ref={name === 'latitude' ? this.latitudeRef : name === 'longitude' ? this.longitudeRef : null}
          // onChange={this.onChange.bind(this)}
          value={isNil(properties.displayVal) ? this.state[name] : properties.displayVal} /> */}
        <input type='text'
          name={name}
          id={name}
          className='default-name-textfield'
          style={{ marginTop: '5px' }}
          placeholder={label}
          ref={name === 'latitude' ? this.latitudeRef : name === 'longitude' ? this.longitudeRef : null}
          onChange={this.onChange}
          value={this.state[name] ?? ''} // Ensure it always uses state
        />
      </div>
    )
  }

  componentDidUpdate() {
    // console.log(this.state.name, "=======> componentDidUpdate (state updated)");
  }

  colorChange(e) {
    //for sketch picker
    const { editable } = this.props.leftToolbarState,
      { type } = this.props,
      measureType = editable ? editable.measureType : type
    this.setState({ color: e.hex }, () => {
      const colorSettings = measureType === 'line' ? { strokeColor: this.state.color } :
        { strokeColor: this.state.color, fillColor: this.state.color }
      this.shape.setOptions(colorSettings)
    })
  }

  // Live preview for the line editor: apply the current color + line style + width to
  // the polyline using the same options tracks use, so lines render identically.
  applyLineStyle = () => {
    if (!this.shape || typeof this.shape.setOptions !== 'function') return
    const { color, lineStyle, lineWidth } = this.state
    try { this.shape.setOptions(trackPolylineOptions(color, lineStyle, lineWidth)) } catch (e) { /* map not ready */ }
  }
  onLineColor = (c) => this.setState({ color: c }, this.applyLineStyle)
  onLineStyle = (s) => this.setState({ lineStyle: s }, this.applyLineStyle)
  onLineWidth = (w) => this.setState({ lineWidth: w }, this.applyLineStyle)

  // Live preview for polygon/circle: colour applies to both stroke + fill, plus width.
  applyShapeStyle = () => {
    if (!this.shape || typeof this.shape.setOptions !== 'function') return
    const { color, lineWidth } = this.state
    try { this.shape.setOptions({ strokeColor: color, fillColor: color, strokeWeight: lineWidth }) } catch (e) { /* map not ready */ }
  }
  onShapeColor = (c) => this.setState({ color: c }, this.applyShapeStyle)
  onShapeWidth = (w) => this.setState({ lineWidth: w }, this.applyShapeStyle)

  getColorSelection() {
    const colors = ['#0000FF', '#90FF00', '#589500', '#FFFF00', '#FF6800', '#FF0000'],
      { color } = this.state
    return (
      <div>
        <div>LINE & FILL COLOR</div>
        <div style={{ display: 'flex', marginTop: '10px', marginBottom: '10px' }}>
          {
            colors.map(c => {
              const active = color.toUpperCase() == c.toUpperCase(),
                border = active ? '4px solid #c1c0c0' : ''
              return (<div onClick={(e) => {
                const { editable } = this.props.leftToolbarState,
                  { type } = this.props,
                  { unlocked } = this.state,
                  measureType = editable ? editable.measureType : type
                this.setState({ color: c }, () => {
                  const colorSettings = measureType === 'line' ? { strokeColor: this.state.color } :
                    { strokeColor: this.state.color, fillColor: this.state.color }
                  if (this.shape) this.shape.setOptions(colorSettings)
                })
              }}
                key={`shape-color-${c}`}
                className='color-option'
                style={{
                  backgroundColor: c,
                  border
                }}>
                {
                  active ? (<div className='color-active'></div>) : null
                }
              </div>)
            })
          }
        </div>
      </div>
    )
  }

  shapeReset() {
    const { editable } = this.props.leftToolbarState,
      geoJson = JSON.parse(editable.geoJson),
      coords = editable.measureType === 'line' || editable.measureType === 'circle' ? geoJson.features[0].geometry.coordinates :
        editable.measureType === 'polygon' ? geoJson.features[0].geometry.coordinates[0] : [],
      options = {}
    const shapeColor = geoJson.features[0].properties.line?.color ?? geoJson.features[0].properties.color
    options['strokeColor'] = shapeColor
    if (editable.measureType === 'line' || editable.measureType === 'polygon') {
      if (this.shape) options['path'] = coords.map(coord => new google.maps.LatLng(coord[1], coord[0]))
      if (editable.measureType === 'polygon') {
        options['fillColor'] = shapeColor
      }
    } else if (editable.measureType === 'circle') {
      options['fillColor'] = shapeColor
      options['radius'] = geoJson.features[0].properties.radius
      options['center'] = new google.maps.LatLng(geoJson.features[0].geometry.coordinates[1], geoJson.features[0].geometry.coordinates[0])
    }

    if (this.shape && typeof this.shape.setOptions === 'function') {
      this.shape.setOptions(options);
    }

  }

  takeScreenshot = () => {
    const targetElement = document.getElementById("map");
    if (!targetElement) {
      console.error("Target element not found!");
      return Promise.reject("Target element not found!");
    }

    // Desired crop dimensions
    const cropWidth = 350; // Width of the cropped area
    const cropHeight = 350; // Height of the cropped area

    // Get the element's dimensions and position
    const elementRect = targetElement.getBoundingClientRect();

    // Calculate the cropping area's top-left corner
    const cropX = (elementRect.width - cropWidth) / 2;
    const cropY = (elementRect.height - cropHeight) / 2;

    // Capture the element using html2canvas
    return html2canvas(targetElement, { useCORS: true })
      .then((canvas) => {
        // Create a new canvas for the cropped image
        const croppedCanvas = document.createElement("canvas");
        croppedCanvas.width = cropWidth;
        croppedCanvas.height = cropHeight;

        const ctx = croppedCanvas.getContext("2d");

        // Draw the specific portion of the original canvas onto the new canvas
        ctx.drawImage(
          canvas,
          cropX, // Start x of crop area in the original canvas
          cropY, // Start y of crop area in the original canvas
          cropWidth, // Width of the crop area
          cropHeight, // Height of the crop area
          0, // Place x for cropped canvas
          0, // Place y for cropped canvas
          cropWidth, // Width of cropped canvas
          cropHeight // Height of cropped canvas
        );

        return new Promise((resolve, reject) => {
          croppedCanvas.toBlob((blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Failed to create blob from cropped canvas"));
            }
          }, "image/png");
        });
      })
      .catch((error) => {
        console.error("Error capturing screenshot: ", error);
        throw error;
      });
  };

  saveShape = (type) => {
    let pathLength = type != "circle" && (this.shape?.getPath()?.getLength() ?? null);
    let { leftToolbarState } = this.props
    if (leftToolbarState.editable) {
      let { name, id, notes, photoId, shapeName, shapeNotes, nameValue } = this.state
      const { boundaryUpdateRequest, circleUpdateRequest, lineUpdateRequest, polygonUpdateRequest, enableMapObject, collapseLeftToolbar } = this.props

      if (leftToolbarState.editable.measureType !== 'track') {
        let geoJson =
          type === "line"
            // In 3D mode this.shape is null — preserve existing geometry from editable
            ? (this.shape && typeof this.shape.getPath === 'function'
                ? shapeUtils.createGeoLine(this.shape, false, this.state.lineStyle, this.state.lineWidth)
                : (leftToolbarState.editable?.geoJson ?? null))
            : type === "polygon"
              ? shapeUtils.createGeoPoly(this.shape, this.state.lineWidth)
              : type === "circle"
                ? shapeUtils.createGeoCircle(this.shape, this.state.lineWidth)
                : null;
        // Always stamp the user-selected color into the geoJson for lines —
        // createGeoLine reads shape.strokeColor which can be stale or missing.
        if (type === "line" && geoJson && this.state.color) {
          try {
            const _g = JSON.parse(geoJson)
            if (_g.features?.[0]?.properties) {
              if (_g.features[0].properties.line) _g.features[0].properties.line.color = this.state.color
              _g.features[0].properties.color = this.state.color
              geoJson = JSON.stringify(_g)
            }
          } catch { /* leave geoJson as-is */ }
        }

        let userId = this.props.user.id,
          measurementTypeId = type === 'polygon' ? MEASUREMENT_TYPES.POLYGON : type === 'line' ? MEASUREMENT_TYPES.LINE : type === 'circle' ? MEASUREMENT_TYPES.CIRCLE : '',
          measureObj = {
            id,
            name: this.state.name,
            notes: shapeNotes,
            photoId,
            userId,
            geoJson,
            measurementTypeId,
            public: false
          }

        const updateFunc = (type === 'circle' ? circleUpdateRequest : type === 'line' ? lineUpdateRequest : type === 'boundary' ? boundaryUpdateRequest : polygonUpdateRequest)
        updateFunc(measureObj)
          .then(res => {
            console.log('helo world')
            collapseLeftToolbar()
            enableMapObject()
            this.setState({ colorDidMount: this.state.color })
          })
          .catch(err => {
            console.error(`Could not update ${type}`, err)
          })
      } else if (leftToolbarState.editable.measureType === 'track') {
        // Tracks now route to TrackDetails, so this branch is defensive. Build an
        // explicit DTO (no server-owned created/updated, no in-place mutation of the
        // Redux object) to match the shape path above — WEB-7014.
        const t = leftToolbarState.editable
        const updatedInfo = {
          id: t.id,
          name,
          notes,
          photoId: t.photoId,
          userId: this.props.user.id,
          geoJson: t.geoJson,
          measurementTypeId: MEASUREMENT_TYPES.TRACK,
          public: t.public ?? false
        }
        this.props.trackUpdateRequest(updatedInfo)
          .then(() => {
            collapseLeftToolbar()
            enableMapObject()
          })
          .catch(err => {
            console.error(`Unable to update track`, err)
          })
      }
    } else {
      if (this.state.shapePoints || type == 'circle') {
        if (!type) {
          return;
        }

        if (this.infoBox) {
          this.infoBox.setMap(null)
        }

        if (type === "circle") {
          this.removeListeners();
          typeof this.shape?.setEditable === 'function' && this.shape.setEditable(false)
          // Center and zoom the map to focus on the shape
          const center = this.shape.getCenter();
          const lat = center.lat();
          const lng = center.lng();
          this.props.mapReference.setCenter({ lat, lng });
          // this.props.mapReference.setZoom(6);
        }
        // Handle unfinished shapes for line and polygon
        if (((type === "line" || type === "polygon" || type === "circle") && (
          // !this.state.doubleClicked &&
          !this.props.leftToolbarState.editable))) {
          // this.removeListeners();
          if (((type === "polygon" && pathLength > 3) || (type === "line" && pathLength > 2) || type === "circle")) {
            let lengthNum
            if (type === "polygon" || type === "line") {
              this.removeListeners();

              this.shape && this.shape.getPath() && this.shape.getPath().pop();

              // Calculate center for line or polygon
              const path = this.shape && this.shape.getPath();
              let latSum = 0, lngSum = 0;
              lengthNum = path && path.getLength();

              path && path.forEach((vertex) => {
                latSum += vertex.lat();
                lngSum += vertex.lng();
              });

              const centerLat = path && latSum / lengthNum;
              const centerLng = path && lngSum / lengthNum;

              this.props.mapReference.setCenter({ lat: centerLat, lng: centerLng });

            } // Optionally, adjust zoom

            if ((type === "line" && lengthNum > 1) || (type === "polygon" && lengthNum >= 3) || (type === "circle")) {
              this.setState({ loadSpinner: true });
              setTimeout(() => {
                this.takeScreenshot()
                  .then((blob) => {
                    // Prepare the photo upload payload
                    const data = new FormData();
                    const photoInfo = {
                      typeId: type === "polygon" ? 3 : type === "line" ? 4 : 5, // Type ID based on shape
                      name: "map-screenshot",
                    };
                    data.append("photo", blob);
                    data.append("photoInfo", JSON.stringify(photoInfo));

                    // Upload the photo
                    return this.props.photoUploadRequest(data);
                  })
                  .then((photoResponse) => {
                    console.log("Photo uploaded successfully:", photoResponse);

                    // Get photo ID from the response
                    const photoId = photoResponse?.id;

                    // Create the geoJson based on the shape type
                    const geoJson =
                      type === "line"
                        ? shapeUtils.createGeoLine(this.shape, false, this.state.lineStyle, this.state.lineWidth)
                        : type === "polygon"
                          ? shapeUtils.createGeoPoly(this.shape, this.state.lineWidth)
                          : type === "circle"
                            ? shapeUtils.createGeoCircle(this.shape, this.state.lineWidth)
                            : null;

                    // Prepare the measurement object
                    const measureObj = {
                      name: this.state.name,
                      notes: this.state.shapeNotes,
                      photoId,
                      userId: this.props.user.id,
                      geoJson,
                      measurementTypeId: type === "polygon" ? MEASUREMENT_TYPES.POLYGON : type === "line" ? MEASUREMENT_TYPES.LINE : MEASUREMENT_TYPES.CIRCLE,
                      public: false,
                    };

                    // Select the appropriate create request function
                    const { circleCreateRequest, lineCreateRequest, polygonCreateRequest } = this.props;
                    const createFunc =
                      type === "circle" ? circleCreateRequest : type === "line" ? lineCreateRequest : polygonCreateRequest;

                    // Call the create function
                    return createFunc(measureObj);
                  })
                  .then(() => {
                    console.log(`${type.charAt(0).toUpperCase() + type.slice(1)} created successfully`);
                    // Collapse the toolbar and enable map object after creation
                    const { collapseLeftToolbar, enableMapObject } = this.props;
                    this.setState({ loadSpinner: false });
                    collapseLeftToolbar();
                    enableMapObject();
                  })
                  .catch((error) => {
                    if (error?.status == 400) {
                      this.setState({ tooManyObjects: true })
                    }

                    if (error?.status !== 0) {
                      console.error(`Error saving ${type}:`, error?.message || error);
                    }
                    this.setState({ loadSpinner: false });
                  });
              }, 1000);
            }
          }
          else {
            this.addPolyListeners()
          }
        } else {

        }
      }
    }
  };


  cancelUpgrade() {
    this.props.collapseLeftToolbar()
  }

  handleUpgrade() {
    let accessToken = this.props.auth
    showHideSubscriptionModal(accessToken)
  }

  // onChange(e) {
  //   const { target } = e,
  //     { unlocked, name } = this.state
  //   console.log(target.name, '=============target')
  //   console.log(e.target.value, '=============eeeeeeeee')
  //   if (target.name === 'latitude') {
  //     this.latitude = target.value
  //     const newPos = new google.maps.LatLng(parseFloat(this.latitude), parseFloat(this.longitude))
  //     this.marker.setPosition(newPos)
  //   }
  //   if (target.name === 'longitude') {
  //     this.longitude = target.value
  //     const newPos = new google.maps.LatLng(parseFloat(this.latitude), parseFloat(this.longitude))
  //     this.marker.setPosition(newPos)
  //   }
  //   this.setState({ [target.name]: target.value }, () => {
  //     console.log(this.state[target.name], `===========> Updated ${target.name}`); // Logs updated state
  //   });

  //   // Use setTimeout to check the updated value asynchronously
  //   setTimeout(() => {
  //     console.log(this.state[target.name], `===========> Delayed ${target.name} (should be updated)`);
  //   }, 0);
  //   // if (target.name == 'name') {
  //   //   console.log(target.value, '=========in codition')
  //   //   this.setState({ name: target.value })
  //   // }
  //   // else
  //   //   this.setState({ [target.name]: target.value })
  //   console.log(name, '===========>name')
  // }


  onChange(e) {
    const { target } = e;
    const { name, value } = target;
    if ([name] == 'name') {
      this.setState({ [name]: value }, () => { });
    } else {
      this.setState({ [name]: value }, () => { });
    }
  }


  removeShape() {
    const { leftToolbarState, collapseLeftToolbar, disableMapObject, enableMapObject, type, boundaryDeleteRequest, circleDeleteRequest, lineDeleteRequest, polygonDeleteRequest } = this.props,
      { editable } = leftToolbarState,
      measureType = editable.measureType ? editable.measureType : type,
      // The deletes reject when they fail (WEB-7103); the shape stays in the store and returns on the next draw.
      logFailure = err => console.error(`Couldn't delete ${measureType} ${editable.id}:`, err)
    if (measureType === 'circle') {
      circleDeleteRequest(editable.id).catch(logFailure)
    }
    if (measureType === 'line') {
      lineDeleteRequest(editable.id).catch(logFailure)
    }
    if (measureType === 'polygon') {
      polygonDeleteRequest(editable.id).catch(logFailure)
    }
    if (measureType === 'boundary') {
      boundaryDeleteRequest(editable.id)
    }
    editable.mapObj().setMap(null)
    collapseLeftToolbar()
    enableMapObject()
  }

  cancelRemoval() {
    this.setState({ confirmRemoval: false })
  }

  getCursor() {
    const { unlocked } = this.state
    return unlocked ? 'pointer' : 'not-allowed'
  }

  render() {
    const { collapseLeftToolbar, enableMapObject, leftToolbarState, type, circleDeleteRequest, lineDeleteRequest, polygonDeleteRequest, mapReference } = this.props,
      { editable } = leftToolbarState,
      { unlocked, noUndo, geoJsonState, loadSpinner } = this.state,
      shapeType = editable ? editable.measureType : type,
      iconStyles = {
        fontSize: '24px',
        height: '24px',
        position: 'relative',
        top: '5px',
        float: 'right'
      }

    const isDisabled = (!loadSpinner && this.state.pathLength > 3) || !editable;
    let cursorVal = isDisabled || editable ? 'pointer' : 'no-drop !important'
    return (
      <div className='tools-content'>
        {loadSpinner && <div className='markers-load-spinner'>
          <div className="loader-spinner"></div>
        </div>}
        {editable ? (
          <div>
            <div>
              {shapeType === 'track' || shapeType === 'boundary' ? null : !unlocked ? <Lock style={iconStyles}
                onClick={() => {
                  this.setState({ propertiesSet: false, unlocked: true }, () => {
                    this.doublePending = false
                    typeof this.shape?.setEditable === 'function' && this.shape.setEditable(true)
                    // Also let the whole shape be moved (dragged), like a circle.
                    typeof this.shape?.setDraggable === 'function' && this.shape.setDraggable(true)
                    this.attachEditListener()
                  })
                }
                }></Lock> : <LockOpen style={iconStyles}
                  onClick={() => {
                    typeof this.shape?.setEditable === 'function' && this.shape.setEditable(false)
                    typeof this.shape?.setDraggable === 'function' && this.shape.setDraggable(false)
                    this.setState({ propertiesSet: true, unlocked: false })
                  }}></LockOpen>}
            </div>
            <div className='tools-header'>
              {`${shapeType} Details`}
            </div>
            <ObjectDetails geoJson={geoJsonState ? geoJsonState : this.geoJson} data={this.chartData} />
          </div>
        ) : null
        }
        {
          shapeType === 'track' && this.geoJson ? <ElevationChart
            data={this.chartData}
            xKey='0'
            yKey='1'
            geoJson={this.geoJson.features[0].properties.stats}
          /> : null
        }
        {
          shapeType === 'line' && this.state.elevationProfile.length >= 2 ? (
            <div style={{ margin: '4px 0 12px' }}>
              <div style={{ fontSize: 11, letterSpacing: '0.8px', color: '#c1c0c0', marginBottom: 6 }}>
                ELEVATION PROFILE
              </div>
              <TrackChart
                points={this.state.elevationProfile}
                units={this.props.userPreferences.units}
                mode='view'
                color={this.state.color}
                height={104}
                showTimeSpeed={false}
              />
            </div>
          ) : null
        }
        {this.makeTextInput({ name: 'name', label: 'Name', width: '100%' })}
        < div style={{ marginTop: '10px', marginBottom: '10px' }
        }>
          <label htmlFor='notes'
            style={{ fontSize: '12px' }}>Notes:
            <textarea name='shapeNotes'
              id='shapeNotes'
              className='default-name-textfield '
              placeholder=' '
              style={{
                height: 100,
                padding: 10,
              }}
              onChange={this.onChange.bind(this)}
              value={this.state.shapeNotes} />
          </label>
        </div >

        {
          shapeType === 'line' ? (
            <div className="track-details-root" style={{ margin: '4px 0 14px', height: 'auto' }}>
              <StyleControls
                colors={TRACK_COLORS} color={this.state.color} onColor={this.onLineColor}
                lineStyles={LINE_STYLES} lineStyle={this.state.lineStyle} onLineStyle={this.onLineStyle}
                widths={TRACK_WIDTHS} lineWidth={this.state.lineWidth} onWidth={this.onLineWidth}
                isPro={true}
              />
            </div>
          ) : (shapeType === 'circle' || shapeType === 'polygon') ? (
            <div className="track-details-root" style={{ margin: '4px 0 14px', height: 'auto' }}>
              <StyleControls
                colors={TRACK_COLORS} color={this.state.color} onColor={this.onShapeColor}
                widths={TRACK_WIDTHS} lineWidth={this.state.lineWidth} onWidth={this.onShapeWidth}
                isPro={true} showLineStyle={false}
              />
            </div>
          ) : shapeType !== 'boundary' && shapeType !== 'track' ?
            this.getColorSelection() : null
        }
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: ' space-between' }}>
          {
            editable ? <button style={{
              width: '32%',
              margin: '0',
              backgroundColor: '#ff6800',
            }}
              onClick={() => {
                this.setState({ confirmRemoval: true })
              }}>Delete</button> :
              type != 'circle' ?
                <button
                  id='undo-button'
                  style={{
                    width: '32%',
                    margin: '0',
                    backgroundColor: !noUndo || this.state.pathLength < 2 ? 'Grey' : '#ff6800',
                    pointerEvents: 'auto',
                    cursor: noUndo ? 'pointer' : 'no-drop !important',
                  }}
                  onClick={() => this.onUndoValue()}>Undo</button> :
                <button style={{
                  width: '32%',
                  margin: '0',
                  backgroundColor: !noUndo || this.state.pathLength < 2 ? 'Grey' : '#ff6800',
                }}
                  onClick={() => this.onUndoValue()}>Undo</button>
          }
          <button onClick={() => {
            if (editable) {
              if (editable.measureType === "boundary") {
                collapseLeftToolbar();
              }
              else if (shapeType !== 'track') {
                try { this.shapeReset() } catch (e) { console.warn('shapeReset error', e) }
              } else {
                collapseLeftToolbar();
                enableMapObject();
              }
            }
            collapseLeftToolbar();
            enableMapObject();

          }}
            style={{
              width: '32%',
              margin: '0',
              backgroundColor: 'grey'
            }}>Cancel</button>
          <button
            id='save-button'
            onClick={() => {
              this.saveShape(shapeType);
            }}
            style={{
              width: '32%',
              margin: '0',
              backgroundColor: editable ? '#589500' : (loadSpinner ? 'grey' : ((type === "polygon" && this.state.pathLength > 3) || (type === "line" && this.state.pathLength > 2) || (type === "circle") ? '#589500' : 'grey')),
              cursor: cursorVal,
            }}>Save Changes</button>
        </div>


        {this.state.confirmRemoval ? <ConfirmRemoval
          remove={this.removeShape.bind(this)}
          cancel={this.cancelRemoval.bind(this)}
          type={shapeType} /> : null}

        {this.state.tooManyObjects ?
          <TooManyObjects
            cancel={this.cancelUpgrade.bind(this)}
            upgrade={this.handleUpgrade.bind(this)}
          /> :
          null
        }

      </div >
    )
  }
}

const mapStateToProps = state => ({
  leftToolbarState: state.leftToolbarState,
  token: state.auth.token,
  mapReference: state.mapReference(),
  user: state.user,
  circles: state.circles,
  polygons: state.polygons,
  lines: state.lines,
  auth: state.auth,
  userPreferences: state.userPreferences
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  enableMapObject: () => dispatch(enableMapObject()),
  disableMapObject: () => dispatch(disableMapObject()),
  blockFeatures: () => dispatch(blockFeatures()),
  unBlockFeatures: () => dispatch(unBlockFeatures()),
  boundaryUpdateRequest: boundary => dispatch(boundaryUpdateRequest(boundary)),
  boundaryDeleteRequest: id => dispatch(boundaryDeleteRequest(id)),
  circleCreateRequest: circle => dispatch(circleCreateRequest(circle)),
  circleUpdateRequest: circle => dispatch(circleUpdateRequest(circle)),
  circleDeleteRequest: id => dispatch(circleDeleteRequest(id)),
  lineCreateRequest: line => dispatch(lineCreateRequest(line)),
  lineUpdateRequest: line => dispatch(lineUpdateRequest(line)),
  lineDeleteRequest: id => dispatch(lineDeleteRequest(id)),
  polygonCreateRequest: poly => dispatch(polygonCreateRequest(poly)),
  polygonUpdateRequest: poly => dispatch(polygonUpdateRequest(poly)),
  polygonDeleteRequest: id => dispatch(polygonDeleteRequest(id)),
  trackUpdateRequest: track => dispatch(trackUpdateRequest(track)),
  trackDeleteRequest: id => dispatch(trackDeleteRequest(id)),
  photoUploadRequest: data => dispatch(photoUploadRequest(data))
})


export default connect(mapStateToProps, mapDispatchToProps)(ShapeDetails)
